export default __webpack_public_path__ + "static/media/logo.15e1942a.png";